import React from "react";
import { Routes, Route } from "react-router-dom";
import "./CSS/Global.css";
import Header from "./Components/Header";
import Home from "./Components/Home";
import AboutPage from "./Components/AboutPage";
import Footer from "./Components/Footer";
import NewServicePage from "./Components/NewServicePage"
import ServicePage from "./Components/ServicePage";
import ContactPage from "./Components/ContactPage";
import PersonalLoanInfo from "./Components/PersonalLoanInfor";
import BusinessLoanInfo from "./Components/BusinessLoanInfo";
import HomeLoanInfo from "./Components/HomeLoanInfo";
import MortgageLoanInfo from "./Components/MortgageLoanInfo";
import AutomobileLoanInfo from "./Components/AutoMobileLoanInfo";
import AgriculturalLoanInfo from "./Components/AgricultureLoanInfo";
import LoanAgainstSharesInfo from "./Components/LoanAgainstSharesInfo";
import EducationLoanInfo from "./Components/EducationLoanInfo";
import GoldLoanInfo from "./Components/GoldLoanInfo";
import LoanEMICalculator from "./Components/LoanEMICalulator";
import HomeMainSection from "./Components/HomeMainSection";
import ApplyNow from "./Components/ApplyNow";
import ScrollToTop from "./Components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import ChannelPartners from "./Components/ChannelPartner";
import CarLoanInfo from "./Components/CarLoanInfo";
import WorkingCapitalInfo from "./Components/WorkingCapitalInfo";
import AuditAssuranceInfo from "./Components/AuditAssuranceInfo";
import FinancialHygieneInfo from "./Components/FinancialHygieneInfo";
import IndianTaxAdvisoryInfo from "./Components/IndianTaxAdvisoryInfo";
import CorporateAdvisoryInfo from "./Components/CorporateAdvisoryInfo";
import RegistrationCertificationsInfo from "./Components/RegistrationCertificationsInfo";
import WorkingCapitalManagementInfo from "./Components/WorkingCapitalManagementInfo";
import FundBasedLendingInfo from "./Components/FundBasedLendingInfo";
import NonFundBasedLendingInfo from "./Components/NonFundBasedLendingInfo";
import DebtSyndicationInfo from "./Components/DebtSyndicationInfo";
import WhatsAppButton from "./Components/WhatsAppButton";

const App = () => {
  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-KRS-FinSolutions" element={<AboutPage />} />
        <Route path="/Our-services" element={<NewServicePage />} />
        <Route path="/loan-services-india" element={<ServicePage />} />
        <Route path="/contact-loan-experts" element={<ContactPage />} />
        <Route path="/personal-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<PersonalLoanInfo />} />
        <Route path="/business-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<BusinessLoanInfo />} />
        <Route path="/home-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<HomeLoanInfo />} />
        <Route path="/mortgage-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<MortgageLoanInfo />} />
        <Route path="/education-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<EducationLoanInfo />} />
        <Route path="/gold-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<GoldLoanInfo />} />
        <Route path="/car-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<CarLoanInfo />} />
        <Route path="/working-capital-loan-mumbai-thane-palghar-maharashtra-delhi-india" element={<WorkingCapitalInfo />} />
        <Route path="/emi-calculator-loan" element={<LoanEMICalculator />} />
        <Route path="/home-updates" element={<HomeMainSection />} />
        <Route path="/apply-loan-online" element={<ApplyNow />} />
        <Route path="/channel-partner" element={<ChannelPartners />} />
        <Route path="/loan-against-shares-mumbai-thane-palghar-maharashtra-delhi-india" element={<LoanAgainstSharesInfo />} />
        <Route path="/audit-assurance-services-india" element={<AuditAssuranceInfo />} />
        <Route path="/financial-hygiene-managed-accounting" element={<FinancialHygieneInfo />} />
        <Route path="/indian-tax-advisory" element={<IndianTaxAdvisoryInfo />} />
        <Route path="/corporate-advisory-virtual-cfo" element={<CorporateAdvisoryInfo />} />
        <Route path="/registration-certifications" element={<RegistrationCertificationsInfo />} />
        <Route path="/working-capital-management-mumbai-thane-palghar-maharashtra-delhi-india" element={<WorkingCapitalManagementInfo />} />
        <Route path="/fund-based-lending-mumbai-thane-palghar-maharashtra-delhi-india" element={<FundBasedLendingInfo />} />
        <Route path="/non-fund-based-lending-mumbai-thane-palghar-maharashtra-delhi-india" element={<NonFundBasedLendingInfo />} />
        <Route path="/debt-syndication-mumbai-thane-palghar-maharashtra-delhi-india" element={<DebtSyndicationInfo />} />
      </Routes>
      <WhatsAppButton />
      <Footer />
      <ToastContainer/>
    </>
  );
};

export default App;
